import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { organizationsKeys } from 'app/queries/organizations/organizationsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.membersByOrg>>;

export const createFetchOrganizationMembersQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        AdminService.getOrganizationUsersList({
          oid: organizationId,
          pageNo: '1',
          pageSize: '1000',
          orderBy: 'createdAt',
          orderType: 'desc',
          search: '',
        }),
        signal,
      ),
    );
